module.exports = __webpack_public_path__ + "static/media/western.6719f3a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/western.png
// module id = 238
// module chunks = 0